import { createReducer } from '@reduxjs/toolkit'

import { DashboardFilter } from 'types/GlobalDashboardFilter'
import type { TSavedDashboardFilterDto } from '@homepal/api-contract'
import { PeriodFilter, CustomPeriodFilter } from 'types/GlobalWidget'

import * as actions from '../../actions/DashboardPage/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type DashboardPageStore = {
  customSegmentByMapper: {
    [widgetId: string]: string | null
  }
  dashboardFilter: DashboardFilter
  editMode: boolean
  periodFilter: PeriodFilter | CustomPeriodFilter | null
  savedDashboardFilter: TSavedDashboardFilterDto | null
}

const INITIAL_STATE: DashboardPageStore = {
  customSegmentByMapper: {},
  dashboardFilter: [],
  editMode: false,
  periodFilter: null,
  savedDashboardFilter: null
}

export type DashboardPageStoreEntry = {
  [K in keyof DashboardPageStore]: {
    key: K
    value: DashboardPageStore[K]
  }
}[keyof DashboardPageStore]

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.updateMany, (state, action) => {
      action.payload.forEach(({ key, value }) => {
        Object.assign(state, { [key]: value })
      })
    })
    .addCase(actions.updateOne, (state, action) => {
      Object.assign(state, { [action.payload.key]: action.payload.value })
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
